import React from "react";

import { Box } from "@mui/material";

interface Props {
  all?: number | string;
  horizontal?: number | string;
  vertical?: number | string;
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left?: number | string;
}

const Margin: React.FC<Props> = ({
  all,
  horizontal,
  vertical,
  top,
  right,
  bottom,
  left,
  children,
}) => {
  return (
    <Box
      margin={all}
      marginX={horizontal}
      marginY={vertical}
      marginTop={top}
      marginRight={right}
      marginBottom={bottom}
      marginLeft={left}
    >
      {children}
    </Box>
  );
};

export default Margin;
